'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _first = require('lodash/first');

var _first2 = _interopRequireDefault(_first);

var _collegeImageComponents = require('@scoir/college-image-components');

var _DetailedTypeahead = require('../DetailedTypeahead');

var _DetailedTypeahead2 = _interopRequireDefault(_DetailedTypeahead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CollegeTypeahead = function (_React$Component) {
    _inherits(CollegeTypeahead, _React$Component);

    function CollegeTypeahead() {
        _classCallCheck(this, CollegeTypeahead);

        return _possibleConstructorReturn(this, (CollegeTypeahead.__proto__ || Object.getPrototypeOf(CollegeTypeahead)).apply(this, arguments));
    }

    _createClass(CollegeTypeahead, [{
        key: 'getDescription',
        value: function getDescription(result) {
            if (result.City && result.State) {
                return result.City + ', ' + result.State;
            } else if (result.City) {
                return result.City;
            }
            return result.State;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                labelKey = _props.labelKey,
                _resultDescriptionFn = _props.resultDescriptionFn;

            return _react2.default.createElement(_DetailedTypeahead2.default, Object.assign({ className: 'college-typeahead-comp'
            }, this.props, {
                imgSrcFn: function imgSrcFn(result) {
                    return (0, _collegeImageComponents.getThumbImageUrl)(result.Scid);
                },
                imgSrcFallbackFn: function imgSrcFallbackFn() {
                    return _collegeImageComponents.DEFAULT_CREST_THUMB;
                },
                resultNameFn: function resultNameFn(result) {
                    return result[labelKey];
                },
                resultDescriptionFn: function resultDescriptionFn(result) {
                    return _resultDescriptionFn ? _resultDescriptionFn(result) : _this2.getDescription(result);
                },
                onChange: function onChange(selected) {
                    return _this2.props.onSelect((0, _first2.default)(selected));
                }
            }));
        }
    }]);

    return CollegeTypeahead;
}(_react2.default.Component);

CollegeTypeahead.propTypes = {
    notListedOption: _propTypes2.default.object,
    align: _DetailedTypeahead2.default.propTypes.align,
    onSelect: _propTypes2.default.func.isRequired,
    onSearch: _propTypes2.default.func.isRequired,
    onPaginate: _propTypes2.default.func,
    resultDisabledMessageFn: _propTypes2.default.func,
    resultDescriptionFn: _propTypes2.default.func,
    clearOnSelect: _propTypes2.default.bool,
    placeholder: _propTypes2.default.string,
    filterByFn: _propTypes2.default.func,
    labelKey: _propTypes2.default.string,
    allowNew: _propTypes2.default.bool,
    allowNewSelectionPrefix: _propTypes2.default.string,
    menuItemClassName: _propTypes2.default.string,
    maxResults: _propTypes2.default.number,
    bsSize: _DetailedTypeahead2.default.propTypes.bsSize,
    theme: _DetailedTypeahead2.default.propTypes.theme,
    id: _DetailedTypeahead2.default.propTypes.id
};
CollegeTypeahead.defaultProps = {
    placeholder: 'Search for college',
    allowNewSelectionPrefix: 'Name: ',
    labelKey: 'SchoolName',
    id: 'ct-college-typeahead'
};

CollegeTypeahead.themes = _DetailedTypeahead2.default.themes;
CollegeTypeahead.DismissableItem = _DetailedTypeahead2.default.DismissableItem;
exports.default = CollegeTypeahead;
//# sourceMappingURL=index.js.map